import dateToString from '../../../function/dateToString';
import { defaultPerPageValue } from '../../../constants/PaginationPerPageConstants';
import { PravoEuFilter } from '../../../model/PravoEuFilter';
import { sortValues } from '../../../constants/PravoEuSortConstants';

export default (
  page: number,
  perPage: number,
  sort: Array<string>,
  filter: PravoEuFilter,
): URLSearchParams => {
  const updatedSearchParams = new URLSearchParams();

  if (filter.hladanyVyraz) {
    updatedSearchParams.set('hladanyVyraz', filter.hladanyVyraz);
  }

  if (filter.celex) {
    updatedSearchParams.set('celex', filter.celex);
  }

  if (filter.rokUverejnenia) {
    updatedSearchParams.set('rokUverejnenia', `${filter.rokUverejnenia}`);
  }

  if (filter.eurovoc) {
    updatedSearchParams.set('eurovoc', filter.eurovoc);
  }

  if (filter.type?.kod) {
    updatedSearchParams.set('type', filter.type.kod);
  }

  if (filter.autor?.kod) {
    updatedSearchParams.set('autor', filter.autor.kod);
  }

  if (filter.zmluva) {
    updatedSearchParams.set('zmluva', filter.zmluva);
  }

  if (filter.datumUverejneniaOd) {
    updatedSearchParams.set('datumUverejneniaOd', dateToString(filter.datumUverejneniaOd));
  }

  if (filter.datumUverejneniaDo) {
    updatedSearchParams.set('datumUverejneniaDo', dateToString(filter.datumUverejneniaDo));
  }

  if (filter.datumSchvaleniaOd) {
    updatedSearchParams.set('datumSchvaleniaOd', dateToString(filter.datumSchvaleniaOd));
  }

  if (filter.datumSchvaleniaDo) {
    updatedSearchParams.set('datumSchvaleniaDo', dateToString(filter.datumSchvaleniaDo));
  }

  if (filter.datumUcinnostiOdOd) {
    updatedSearchParams.set('datumUcinnostiOdOd', dateToString(filter.datumUcinnostiOdOd));
  }

  if (filter.datumUcinnostiOdDo) {
    updatedSearchParams.set('datumUcinnostiOdDo', dateToString(filter.datumUcinnostiOdDo));
  }

  if (filter.datumUcinnostiDoOd) {
    updatedSearchParams.set('datumUcinnostiDoOd', dateToString(filter.datumUcinnostiDoOd));
  }

  if (filter.datumUcinnostiDoDo) {
    updatedSearchParams.set('datumUcinnostiDoDo', dateToString(filter.datumUcinnostiDoDo));
  }

  if (filter.datumUzavierkyOd) {
    updatedSearchParams.set('datumUzavierkyOd', dateToString(filter.datumUzavierkyOd));
  }

  if (filter.datumUzavierkyDo) {
    updatedSearchParams.set('datumUzavierkyDo', dateToString(filter.datumUzavierkyDo));
  }

  if (filter.datumTranspozicieOd) {
    updatedSearchParams.set('datumTranspozicieOd', dateToString(filter.datumTranspozicieOd));
  }
  if (filter.datumTranspozicieDo) {
    updatedSearchParams.set('datumTranspozicieDo', dateToString(filter.datumTranspozicieDo));
  }

  if (page && page !== 1) {
    updatedSearchParams.set('page', page.toString());
  }

  if (perPage && perPage !== defaultPerPageValue) {
    updatedSearchParams.set('perPage', perPage.toString());
  }

  if (sort[0] && sort[1]) {
    if (!sortValues.includes(sort[0])
      || (sort[1] !== 'asc' && sort[1] !== 'desc')) {
      updatedSearchParams.delete('sort');
    } else {
      updatedSearchParams.set('sort', `${sort[0]},${sort[1]}`);
    }
  }
  return updatedSearchParams;
};
